/**
 * @generated SignedSource<<820c13c646099ecb5149604afcca7bf3>>
 * @relayHash bb0ffcd3ee07a20a6e7bee99ae361456
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 3d3b7f55862392a8e7fc340c23e3564932a5de0b48b0561129e09f6c4620e8ce

import type { ConcreteRequest } from 'relay-runtime';
export type rovoWidgetProviderQuery$variables = {
  cloudId: string;
  cloudIdString: string;
  containerAri: string;
};
export type rovoWidgetProviderQuery$data = {
  readonly agentStudio_widgetByContainerAri: {
    readonly __typename: "AgentStudioWidget";
    readonly agent: {
      readonly __typename: "AgentStudioAssistant";
      readonly id: string;
    } | {
      // This will never be '%other', but we need some
      // value in case none of the concrete values match.
      readonly __typename: "%other";
    } | null;
    readonly isEnabled: boolean | null;
  } | {
    // This will never be '%other', but we need some
    // value in case none of the concrete values match.
    readonly __typename: "%other";
  } | null;
  readonly atlassianStudio_userSiteContext: {
    readonly isCustomAgentsAvailable?: boolean | null;
  } | null;
};
export type rovoWidgetProviderQuery = {
  response: rovoWidgetProviderQuery$data;
  variables: rovoWidgetProviderQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "cloudId"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "cloudIdString"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "containerAri"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "cloudId",
    "variableName": "cloudId"
  }
],
v2 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "isCustomAgentsAvailable"
    }
  ],
  "type": "AtlassianStudioUserSiteContextOutput"
},
v3 = [
  {
    "kind": "Variable",
    "name": "cloudId",
    "variableName": "cloudIdString"
  },
  {
    "kind": "Variable",
    "name": "containerAri",
    "variableName": "containerAri"
  }
],
v4 = {
  "kind": "ScalarField",
  "name": "__typename"
},
v5 = {
  "kind": "ScalarField",
  "name": "isEnabled"
},
v6 = [
  {
    "kind": "ScalarField",
    "name": "id"
  }
],
v7 = {
  "kind": "InlineFragment",
  "selections": (v6/*: any*/),
  "type": "AgentStudioAssistant"
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "rovoWidgetProviderQuery",
    "selections": [
      {
        "args": (v1/*: any*/),
        "kind": "LinkedField",
        "name": "atlassianStudio_userSiteContext",
        "plural": false,
        "selections": [
          (v2/*: any*/)
        ]
      },
      {
        "args": (v3/*: any*/),
        "kind": "LinkedField",
        "name": "agentStudio_widgetByContainerAri",
        "plural": false,
        "selections": [
          (v4/*: any*/),
          {
            "kind": "InlineFragment",
            "selections": [
              (v5/*: any*/),
              {
                "kind": "LinkedField",
                "name": "agent",
                "plural": false,
                "selections": [
                  (v4/*: any*/),
                  (v7/*: any*/)
                ]
              }
            ],
            "type": "AgentStudioWidget"
          }
        ]
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "rovoWidgetProviderQuery",
    "selections": [
      {
        "args": (v1/*: any*/),
        "kind": "LinkedField",
        "name": "atlassianStudio_userSiteContext",
        "plural": false,
        "selections": [
          (v4/*: any*/),
          (v2/*: any*/)
        ]
      },
      {
        "args": (v3/*: any*/),
        "kind": "LinkedField",
        "name": "agentStudio_widgetByContainerAri",
        "plural": false,
        "selections": [
          (v4/*: any*/),
          {
            "kind": "InlineFragment",
            "selections": [
              (v5/*: any*/),
              {
                "kind": "LinkedField",
                "name": "agent",
                "plural": false,
                "selections": [
                  (v4/*: any*/),
                  (v7/*: any*/),
                  {
                    "kind": "InlineFragment",
                    "selections": (v6/*: any*/),
                    "type": "Node",
                    "abstractKey": "__isNode"
                  }
                ]
              }
            ],
            "type": "AgentStudioWidget"
          }
        ]
      }
    ]
  },
  "params": {
    "id": "3d3b7f55862392a8e7fc340c23e3564932a5de0b48b0561129e09f6c4620e8ce",
    "metadata": {},
    "name": "rovoWidgetProviderQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "000b7d5b220d2d981324c500d4aeab75";

export default node;
